<div class="mb-3">
    <mat-button-toggle-group class="w-100 d-flex justify-content-between" [hideSingleSelectionIndicator]="true" [(ngModel)]="selectedLanguage">
        <mat-button-toggle class="w-100" value="en" (change)="onTranslationChange($event)">
            <mwp-text-translate text="English" jsonKey="english" />
        </mat-button-toggle>
        <mat-button-toggle class="w-100" value="es" (change)="onTranslationChange($event)">
            <mwp-text-translate text="Spanish" jsonKey="spanish" />
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>